export const blockInputInvalidPassword = (event: KeyboardEvent) => {
  const allowedChars = /^[\p{L}\p{N}\p{S}\p{P}]*$/u;

  if (event.key?.length === 1 && !allowedChars.test(event.key)) {
    event.preventDefault();
  }
};

export const blockInputInvalidId = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;

  // 영문, 숫자, _, -, @, . 허용 (이메일 형식 지원)
  value = value.replace(/[^a-zA-Z0-9_\-@.]/g, '');

  // _, -, @, . 로 시작하는 경우 제거
  value = value.replace(/^[_\-@.]+/, '');

  if (input.value !== value) {
    input.value = value;
  }
};

export const validateInputCode = (event: Event) => {
  const input = event.target as HTMLInputElement;

  input.value = input.value.replace(/[^a-zA-Z0-9]/g, '');
};
